import script from "./ConsolePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsolePagination.vue?vue&type=script&setup=true&lang=js"

import "./ConsolePagination.vue?vue&type=style&index=0&id=11cb3337&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11cb3337"]])

export default __exports__